import { forwardRef } from 'react';

import classNames from 'classnames';

import styles from './ButtonBase.module.css';

export type ButtonBaseProps = JSX.IntrinsicElements['button'];

/**
 * Render a `<button>` without any appearance. Use this component when you need
 * to wrap an icon or another content with a button, without altering its
 * style.
 *
 * When `aria-disabled`, the button doesn't respond to click events.
 *
 * @see https://corgi-x.tfd.engineering/components/buttonbase
 */
export const ButtonBase = forwardRef<HTMLButtonElement, ButtonBaseProps>(
  (props, ref) => {
    let handleClick = props.onClick;

    if (props['aria-disabled'] === true) {
      handleClick = e => {
        e.preventDefault();
        e.stopPropagation();
      };
    }

    const className = classNames(styles.buttonReset, props.className);

    return (
      <button
        type="button"
        {...props}
        ref={ref}
        className={className}
        onClick={handleClick}
      >
        {props.children}
      </button>
    );
  }
);
